<script setup lang="ts">
interface Props {
  params: {
    count: number;
    current: number;
    perPage: number;
    max?: number;
  };
}
const props = defineProps<Props>();

// 現在の表示範囲
const currentRange = computed(() => {
  if (!props.params.count) return { from: 0, to: 0 };
  const o = props.params.current ? props.params.current : 0;
  let from = o * props.params.perPage + 1;
  let to = from + props.params.perPage - 1;
  if (props.params.count < to) {
    to = props.params.count;
  }
  return { from, to };
});

const prevNext = computed(() => {
  if (!props.params.max) return { prev: 0, next: 0 };

  // 前後を取得
  const pagenation = {
    prev: props.params.current - 1,
    next: props.params.current + 1,
  };

  // 最大値以上になるときは最大とそのひとつ前にする
  if (props.params.max - 1 < pagenation.next) {
    pagenation.next = props.params.max - 1;
    pagenation.prev = props.params.max - 2;
  }

  // 前は0以下にはならない
  if (pagenation.prev < 0) {
    pagenation.prev = 0;
  }

  return pagenation;
});

const currentQuery = computed(() => useRoute().query);

function navigate(off: number) {
  return {
    query: {
      ...currentQuery.value,
      off,
    },
  };
}
</script>

<template>
  <div class="flex justify-end items-center">
    <NuxtLink
      :to="navigate(prevNext.prev)"
      :class="$style.btn"
      aria-label="prev"
    >
      <Icon size="18" name="mdi:chevron-left" />
    </NuxtLink>
    <p class="text-center mx-2 min-w-[100px]" v-show="0 <= params.current">
      <span class="block">{{ params.current + 1 }}ページ</span>
      <span>({{ currentRange.from }} ~ {{ currentRange.to }})</span>
    </p>
    <NuxtLink
      :to="navigate(prevNext.next)"
      :class="$style.btn"
      aria-label="next"
    >
      <Icon size="18" name="mdi:chevron-right" />
    </NuxtLink>
  </div>
</template>

<style module>
.btn {
  @apply bg-gray-100 rounded p-2 text-gray-600  hover:bg-gray-200;
}
</style>
